<template>
  <div class="pa-8" :class="$vuetify.breakpoint.xsOnly ? 'px-0 pt-0' : ''">
    <div v-if="!$vuetify.breakpoint.xsOnly" class="d-flex align-center mb-4">
      <div>
        <v-btn @click="goBack" class="left-arrow" icon>
          <v-icon>mdi-arrow-top-left</v-icon>
        </v-btn>
      </div>
      <div class="ml-2">
        <span class="market-header">Groups</span>
      </div>
    </div>

    <v-row>
      <v-col class="px-3" cols="12">
        <PaymentSetupCard
          v-if="group.is_admin && verifiedAccountCondition"
          :group="group"
        >
        </PaymentSetupCard>
      </v-col>
      <v-col style="" class="pr-0" cols="12" md="8" sm="12">
        <v-card class="bg-group" style="border-radius: 12px">
          <v-card-text class="px-0 pt-0">
            <div style="position: relative">
              <v-img
                :height="$vuetify.breakpoint.xsOnly ? '129.6px' : '232.56px'"
                :src="group.cover_image ? group.cover_image : group_cover"
                class="br-radius"
              >
              </v-img>
              <div class="user-abs">
                <div class="user-name" v-if="!group.picture">
                  <div>{{ getName }}</div>
                </div>
                <v-img v-else class="user-image" :src="group.picture"> </v-img>
              </div>
            </div>
            <!-- SEBI RIA and Badge -->
            <div
              v-if="!group.is_admin && !group.is_participant"
              class="mt-4 user-badge d-flex justify-end align-center"
            >
              <div class="sebi-ria mr-2 d-flex justify-center align-center">
                <div v-if="group.admin_payment_info" class="">
                  SEBI
                  {{ group.admin_payment_info.profile.sebi_registration_num }}
                </div>
                <div>
                  <v-tooltip
                    content-class="tooltip"
                    color="#F7FAFF"
                    bottom
                    max-width="450"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon
                          :small="$vuetify.breakpoint.xsOnly"
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </div>
                    </template>
                    <span class="tooltip-text">
                      Registration granted by SEBI, membership of a SEBI
                      recognized supervisory body (if any) and certification
                      from NISM in no way guarantee performance of the
                      intermediary or provide any assurance of returns to
                      investors.</span
                    >
                  </v-tooltip>
                </div>
              </div>
              <div>
                <v-img class="user-img-badge" :src="premium_badge"> </v-img>
              </div>
            </div>
            <!--  -->
            <!-- sagar -->
            <!-- When Edit group -->
            <div
              v-if="group.is_admin || group.is_participant"
              class="d-flex justify-end mr-3 mt-4"
            >
              <v-btn
                :small="$vuetify.breakpoint.xsOnly"
                @click="shareGroup()"
                color="primary"
                outlined
                class="share-btn"
              >
                <v-icon :small="$vuetify.breakpoint.xsOnly"
                  >mdi-share-variant-outline</v-icon
                >
              </v-btn>
              <v-btn
                @click="editGroup()"
                color="primary"
                outlined
                :small="$vuetify.breakpoint.xsOnly"
                left
                class="edit-btn mx-2"
              >
                <v-icon
                  v-if="!group.is_participant"
                  :small="$vuetify.breakpoint.xsOnly"
                  >mdi-pencil-outline</v-icon
                >
                {{ group.is_participant ? "View Details" : "Edit Details" }}
              </v-btn>
              <group-details-menu
                :admin-profile="group.admin.profile"
                v-if="group.is_admin || group.is_participant"
              ></group-details-menu>
            </div>
          </v-card-text>
          <v-card-text
            class="px-3 pb-2"
            :class="$vuetify.breakpoint.xsOnly ? 'pt-0' : 'pt-5'"
          >
            <!-- Group header name  and disclosure -->
            <div class="d-flex justify-space-between">
              <div>
                <div class="group-header">{{ group.name }}</div>
                <div
                  @click="goToProfile(group.admin)"
                  v-if="group.admin"
                  class="group-subheader"
                >
                  By
                  <span class="gr-subheader">{{
                    group.admin.profile.name
                  }}</span>
                </div>
              </div>
              <!-- Diclosure view -->
              <div @click="routeToLogin()">
                <div
                  @click="openDisclosure(group.disclosure_document)"
                  class="d-flex align-center pointer"
                >
                  <div class="view-disclosure">View Disclosure</div>
                  <div>
                    <v-btn
                      :small="$vuetify.breakpoint.xsOnly"
                      color="primary"
                      icon
                    >
                      <v-icon :small="$vuetify.breakpoint.xsOnly"
                        >mdi-open-in-new</v-icon
                      >
                    </v-btn>
                  </div>
                </div>
                <div
                  class="text-right mr-2"
                  v-if="
                    (group.is_admin || group.is_participant) &&
                    $vuetify.breakpoint.xsOnly
                  "
                >
                  <span @click="openGroupMembers()" class="intru-txt-value">
                    {{ group.active_group_members || 0 }}
                    <span class="ml-1 active-member">Members</span>
                  </span>
                </div>
              </div>
            </div>

            <!-- Chips section -->
            <div class="d-flex justify-space-between align-center">
              <div class="d-flex dashed-border">
                <v-chip-group
                  v-for="(inst, i) in group.types_of_instrument"
                  :key="i.inst"
                  multiple
                  class=""
                  mandatory
                >
                  <!-- :small="$vuetify.breakpoint.xsOnly" -->
                  <v-chip
                    class="pr-4 py-2"
                    active
                    :color="getColor(i)"
                    label
                    outlined
                  >
                    <span class="intru-txt"> {{ inst }} </span>
                  </v-chip>
                </v-chip-group>
              </div>
              <v-chip
                v-if="
                  (group.is_admin || group.is_participant) &&
                  !$vuetify.breakpoint.xsOnly
                "
                class="px-2 py-2"
                active
                color="#333333CC"
                label
                outlined
                @click="openGroupMembers()"
              >
                <span class="intru-txt-value">
                  {{ group.active_group_members || 0 }}
                </span>
                <span class="ml-2 active-member">Active Members</span>
              </v-chip>
            </div>
            <!--  -->
            <!-- Metrics Section  And tabs-->
            <v-row
              class="d-flex justify-space-between align-center"
              :class="$vuetify.breakpoint.xsOnly ? 'mt-0' : 'mt-1'"
            >
              <v-col cols="2" sm="2" md="4">
                <div class="d-flex align-end">
                  <div
                    class="main-label"
                    :class="$vuetify.breakpoint.xsOnly ? 'ml-0' : 'ml-0'"
                  >
                    Metrics
                  </div>
                  <v-tooltip
                    content-class="tooltip"
                    color="#F7FAFF"
                    bottom
                    max-width="260"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon
                          :small="$vuetify.breakpoint.xsOnly"
                          class="ml-1"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-information-outline
                        </v-icon>
                      </div>
                    </template>
                    <span class="tooltip-text">
                      Returns represent past performance, are not a guarantee of
                      future performance, and are not indicative of any specific
                      investment.</span
                    >
                  </v-tooltip>
                </div>
              </v-col>
              <v-col v-if="group.is_admin" class="mr-4" sm="7" md="7">
                <div style="margin-left: 69px !important">
                  <v-tabs
                    hide-slider
                    fixed-tabs
                    v-model="filterValue"
                    color="primary"
                  >
                    <v-tab
                      class="tabs-width"
                      active-class="duration-tabs"
                      v-for="(item, id) in filterItems"
                      :key="id.item"
                    >
                      {{ item.text }}
                    </v-tab>
                  </v-tabs>
                </div>
              </v-col>
            </v-row>
            <!-- Metrics Boxes group details When Edit -->
            <div v-if="kpi_data_loading" class="row-gap pt-0 mt-4">
              <div
                v-for="(item, i) in 6"
                :key="i.id"
                cols="4"
                class="edit-group-details"
              >
                <div>
                  <div>
                    <v-skeleton-loader
                      height="38.4px"
                      type="image"
                    ></v-skeleton-loader>

                    <!-- height="45px" -->
                    <!-- {{ kpiData.closed_trades ? kpiData.closed_trades : "-" }} -->
                  </div>
                  <!-- <div>Closed Trades</div> -->
                </div>
              </div>
            </div>
            <div
              v-else-if="group.is_admin || group.is_participant"
              class="row-gap"
              :class="!$vuetify.breakpoint.xsOnly ? 'mt-4' : 'mt-0'"
            >
              <div
                cols="4"
                class="edit-group-details"
                :class="kpi_data_loading ? 'bg-color' : ''"
              >
                <div>
                  <div>
                    {{ kpiData.closed_trades ? kpiData.closed_trades : "-" }}
                  </div>
                  <div>Closed Trades</div>
                </div>
              </div>
              <div cols="4" class="edit-group-details">
                <div>
                  <div>{{ kpiData.accuracy ? kpiData.accuracy : "-" }}%</div>
                  <div>Accuracy</div>
                </div>
              </div>
              <div cols="4" class="edit-group-details">
                <div>
                  <div>
                    {{ kpiData.holding_period ? kpiData.holding_period : "-" }}
                    Days
                  </div>
                  <div>Holding Period</div>
                </div>
              </div>
              <div cols="4" class="edit-group-details">
                <div>
                  <div>
                    {{ kpiData.risk_reward ? kpiData.risk_reward : "-" }}
                  </div>
                  <div>Risk Reward</div>
                </div>
              </div>
              <div cols="4" class="edit-group-details">
                <div>
                  <div>
                    {{
                      kpiData.avg_trade_return ? kpiData.avg_trade_return : "-"
                    }}
                    %
                  </div>
                  <div>Avg Trade Return</div>
                </div>
              </div>
              <div cols="4" class="edit-group-details">
                <div>
                  <div>{{ kpiData.roi ? kpiData.roi : "-" }} %</div>
                  <div>ROI</div>
                </div>
              </div>
            </div>
            <!-- incluedes text -->
            <div
              v-if="group.is_admin || group.is_participant"
              class="mt-2 includes-trades"
            >
              Includes virtual equity trades only
            </div>
            <!--  Groups details-->
            <div
              v-if="!group.is_admin && !group.is_participant"
              class="d-flex mt-4 pb-3 padding-metrics justify-space-between"
            >
              <div class="details">
                <div>{{ kpiData.closed_trades }}</div>
                <div>Avg. Trades</div>
              </div>
              <div class="details">
                <div>{{ kpiData.accuracy ? kpiData.accuracy : "-" }}%</div>
                <div>Accuracy</div>
              </div>
              <div class="details">
                <div>
                  {{
                    kpiData.avg_trade_return ? kpiData.avg_trade_return : "-"
                  }}%
                </div>
                <div>Avg. Returns</div>
              </div>
            </div>
            <!-- Key Offerings -->
            <div
              v-if="
                key_offers.length && !group.is_admin && !group.is_participant
              "
              class="mt-5"
            >
              <div class="main-label mb-5">Key Offerings</div>
              <div
                v-for="(item, id) in key_offers"
                :key="id"
                class="key-offer mb-2"
              >
                <div>
                  <v-img
                    height="14.86px"
                    width="16px"
                    :src="right_arrow"
                  ></v-img>
                </div>
                <div class="ml-5 key-offering-txt">
                  {{ item.key_offering }}
                </div>
              </div>
            </div>
            <!--  -->
            <!-- Description -->
            <div class="mt-5" v-if="group.description && !group.is_admin">
              <div class="main-label mb-2">Description</div>
              <div v-if="!desMore && group.description.length > 230">
                {{ group.description.substring(0, 250) }}...
                <span @click="desMore = true" class="show-more">
                  Show More</span
                >
              </div>
              <div v-else>
                {{ group.description }}
                <span
                  v-if="group.description.length > 230"
                  @click="desMore = false"
                  class="show-more"
                  >Read Less</span
                >
              </div>
            </div>
          </v-card-text>
          <!-- Groups tabs section -->
          <!-- <v-card-text> -->
          <GroupTabs
            class=""
            :watchlist_data="watchlist_data"
            :group="group"
            ref="groupTabs"
          >
          </GroupTabs>
          <!-- </v-card-text> -->
          <!--  -->
        </v-card>
      </v-col>

      <v-col @click="routeToLogin()" class="pr-0" cols="12" md="4" sm="12">
        <!-- Subsciption Plan -->
        <SubscriptionPlan
          v-if="
            !group.is_admin &&
            !group.is_participant &&
            !$vuetify.breakpoint.xsOnly
          "
          :group="group"
          class="mb-6"
        >
        </SubscriptionPlan>
        <v-dialog width="100%" v-model="openSubs">
          <v-card-title class="title">
            Subscription Plan
            <v-spacer></v-spacer>
            <v-btn
              text
              style="min-width: 10px !important"
              @click="openSubs = false"
            >
              <v-icon color="#fff">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <SubscriptionPlan :group="group"> </SubscriptionPlan>
        </v-dialog>
        <!-- Contact section -->
        <Contact
          :class="$vuetify.breakpoint.xsOnly ? 'mb-15' : ''"
          :group="group"
          :contact="contact"
        >
        </Contact>
        <!--  -->
        <!-- only desktop, agar admin hoga to watchlist show -->
        <!-- {{ watchlist_data.length > 0 }} -->
        <!-- {{ watchlist_length }} -->
        <v-card
          v-if="
            !$vuetify.breakpoint.xsOnly &&
            (group.is_admin ||
              (group.is_watchlist_added && group.is_participant))
          "
          class="mt-6 mb-15"
        >
          <!-- Group Watchlist -->
          <v-card-title>
            <div class="group-contact">Watchlist</div>
          </v-card-title>
          <v-card-text>
            <GroupWatchlist :group="group" :watchlist_data="watchlist_data">
            </GroupWatchlist>
          </v-card-text>
          <!--  -->
        </v-card>
      </v-col>
      <KycDetails
        v-if="group.is_participant && !group.is_kyc_completed"
        :openKyc="kyc_details"
      >
      </KycDetails>
    </v-row>
    <expert-bank-info-modal></expert-bank-info-modal>

    <div
      v-if="
        $vuetify.breakpoint.xsOnly && !group.is_admin && !group.is_participant
      "
      class="bottom-nav px-3"
    >
      <v-btn
        @click="routeToLoginForSubs()"
        block
        height="50px"
        class="subs-btn mx-4"
        color="primary"
      >
        Subscribe Now
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/BaseAxios.js";
import GroupWatchlist from "@/components/Group/PremiumGroups/Watchlist.vue";
import Contact from "@/components/Group/PremiumGroups/Contact.vue";
import SubscriptionPlan from "@/components/Group/PremiumGroups/SubscriptionPlan.vue";
import GroupTabs from "@/components/Group/PremiumGroups/Tabs.vue";
import newAxios from "@/api/newAxios";
import commonFunctions from "@/common/commonFunctions";
import { isAuthenticated } from "@/common/commonFunctions.js";
import helper from "@/helper";
import GroupDetailsMenu from "@/components/GroupDetailsMenu.vue";
import PaymentSetupCard from "@/components/Group/PaymentSetupCard/PaymentSetupCard.vue";

export default {
  name: "premiumGroup",
  components: {
    GroupWatchlist,
    PaymentSetupCard,
    GroupDetailsMenu,
    Contact,
    SubscriptionPlan,
    GroupTabs,
    KycDetails: () => import("@/components/Group/PaymentDetail/KycDetails.vue"),
    ExpertBankInfoModal: () =>
      import("@/components/Group/ExpertBankInfoModal/ExpertBankInfoModal"),
  },
  data() {
    return {
      tab: null,
      isAuth: commonFunctions,
      Authentecated: isAuthenticated,
      openSubs: false,
      watchlist_length: 0,

      // tab_items: ["1D", "1W", "1M", "3M", "6M", "MAX"],
      premium_groups: [],
      state_list: [],
      watchlist_data: [],
      group_cover: require("@/assets/images/group_cover_image.svg"),
      right_arrow: require("@/assets/images/right-arrow.svg"),
      default_user: require("@/assets/images/default_user_photo.png"),
      premium_badge: require("@/assets/images/premium_badge.svg"),

      kpiData: {
        closed_trades: null,
        accuracy: null,
        holding_period: null,
        risk_reward: null,
        avg_trade_return: null,
        roi: null,
      },
      kyc_details: {
        flag: true,
      },
      kpi_data_loading: false,
      filterValue: 0,
      filterItems: [
        { text: "All", value: "ALL" },
        { text: "1D", value: "1DAY" },
        { text: "1W", value: "1WEEK" },
        { text: "1M", value: "1MONTH" },
        // { text: "3M", value: "3MONTH" },
        { text: "6M", value: "6MONTH" },
        { text: "1Y", value: "1YEAR" },
      ],

      loadingGroup: false,
      group: {},
      desMore: false,
      contact: {},
      loading: false,
      key_offers: [],
    };
  },
  watch: {
    filterValue() {
      this.getKpis();
    },
    selectedPlan(newValue) {
      console.log(this.selectedPlan, newValue, "\\\\\\");
      this.getKpis();
    },
  },
  mounted() {
    // this.getPremiumGroups();
    this.groupId = this.$route.params["id"];
    this.getGroupDetail(true);
    this.getKpis();
  },
  computed: {
    selectedPlan() {
      return this.$store.state.subscription.selectedPlan;
    },
    filterTabValue() {
      return this.filterItems[this.filterValue].value;
    },
    getName() {
      let name = this.group.name;
      name = name.split(" ");
      if (name[1]) {
        return (
          name[0].slice(0, 1).toUpperCase() + name[1].slice(0, 1).toUpperCase()
        );
      }
      return name[0].slice(0, 1).toUpperCase();
    },

    verifiedAccountCondition() {
      if (!this.group.is_admin_payment_info) {
        return true;
      } else {
        if (
          this.group.admin_payment_info.verification_status === "Pending" ||
          this.group.admin_payment_info.verification_status === "Rejected"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  created() {
    this.eventBus.$on("refresh-group-detail", () => {
      this.getGroupDetail();
    });
    this.eventBus.$on("getwatchlist-length", (value) => {
      this.watchlist_length = value;
    });
  },
  beforeDestroy() {
    this.eventBus.$off("refresh-group-detail");
    this.eventBus.$off("getwatchlist-length");
  },
  methods: {
    ...mapActions({
      toggleGroupModal: "group/toggleShowGroupModal",
    }),
    goBack() {
      this.$router.go(-1);
    },
    editGroup() {
      let type = this.group.is_participant;
      if (!type) {
        type = "edit";
      } else {
        type = "view";
      }
      this.toggleGroupModal({
        show: true,
        type: this.group.is_participant ? "view" : "edit",
        id: this.$route.params.id,
      });
    },

    routeToLogin() {
      if (!this.Authentecated()) {
        this.$store.dispatch("login/toggleGroupsUserUrl", {
          url: this.$route.params.id,
        });
        this.$router.push({
          name: "login",
        });
      }
    },
    routeToLoginForSubs() {
      if (!this.Authentecated()) {
        this.$store.dispatch("login/toggleGroupsUserUrl", {
          url: this.$route.params.id,
        });
        this.$router.push({
          name: "login",
        });
      } else {
        this.openSubs = true;
      }
    },
    openDisclosure(doc) {
      window.open(doc);
    },
    goToProfile(user) {
      if (this.Authentecated()) {
        if (this.group.is_admin) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: {
              id: user.id,
              name: user.profile.name,
            },
          });
        }
      }
    },
    getColor(i) {
      const colorMap = ["#459393", "#3F7BC3", "#DD9324"];
      return colorMap[i] || "#333333CC"; // Fallback color
    },
    getKpis() {
      this.kpi_data_loading = true;
      const onSuccess = (res) => {
        this.kpiData = res.data.result;
        this.kpi_data_loading = false;
      };
      const onFailure = () => {
        this.kpi_data_loading = false;
      };
      const selectedPlan = this.selectedPlan;
      const planFilterMapping = {
        Daily: "1DAY",
        Weekly: "1WEEK",
        Monthly: "1MONTH",
        Quarterly: "3MONTH",
        Yearly: "1YEAR",
      };
      const filter = planFilterMapping[selectedPlan] || null;
      let params = {};
      // params["user_id"] = this.isAuth.getUserId();
      // params["trade_type"] = "ALL";
      params["group_id"] = this.groupId;
      // params["filters"] = this.filterTabValue;
      params["filters"] = filter;
      newAxios("get", "/api/group-kpis/", {
        params: params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },

    shareGroup() {
      const userId = localStorage.getItem("user_id");
      const url = `${location.protocol}//${location.host}/premium-groups/detail/${this.group.id}?utm_source=user_${userId}&utm_medium=share_link`;
      const text = "Checkout this group on Covesto";
      const title = "Covesto";

      if (!navigator.canShare) {
        navigator.clipboard.writeText(
          `Covesto
          Checkout this group on Covesto.
          ${url}
          `
        );
      }
      helper.shareLink(url, text, title);
    },
    openGroupMembers() {
      this.toggleGroupModal({
        show: true,
        type: this.group.is_participant ? "view" : "edit",
        id: this.$route.params.id,
        members: true,
      });
    },

    getGroupDetail(value) {
      this.loadingGroup = value;
      const successHandler = (res) => {
        this.group = res.data.group_detail;
        this.contact = res.data.user_sebi_details[0];
        this.key_offers = res.data.key_offering;
        this.watchlist_data = res.data.watchlist_data;

        // this.$emit("groupDetailFetched");
        // console.log(this.group);
        this.$store.dispatch("groups/toggleGroupModal", res.data.group_detail);
        this.loadingGroup = false;
        // this.$emit("groupDetailsFetched");
        // if (this.group.is_participant && this.is_kyc_completed) {
        //   this.kyc_details.flag = false;
        // }
        setTimeout(() => {
          this.$refs.groupTabs.getTrades();
        }, 500);
      };
      const failureHandler = () => {
        this.loadingGroup = false;
      };
      let formData = {};
      formData["id"] = this.groupId;
      Axios.request_GET(
        apiUrl.GROUP_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        this.Authentecated() ? true : false
      );
    },
    onGroupDetailFetched() {
      this.$refs.child.getTrades(); // Call child's function
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .user-name {
    width: 84px !important;
    height: 84px !important;
  }
  .user-name > div {
    font-size: 22px !important;
  }
  .user-image {
    width: 84px !important;
    height: 84px !important;
  }
  .group-header {
    font-family: Avenir;
    font-size: 22px !important;
    font-weight: 800;
    line-height: 21.86px !important;
    text-align: left;
  }
  .group-subheader {
    font-family: Avenir;
    font-size: 15px !important;
    font-weight: 500;
    line-height: 36.03px;
    text-align: left;
  }
  .subs-btn {
    border-radius: 4px;
    font-family: Avenir;
    font-size: 20px;
    font-weight: 500;
    line-height: 27.32px;
    text-align: center;
    // height: 52px;
    text-transform: capitalize;
  }
  .view-disclosure {
    font-family: Avenir;
    font-size: 16px !important;
    font-weight: 500;
    line-height: 24px !important;
    text-align: left;
  }
  .user-abs {
    bottom: -40px !important;
  }
  .intru-txt {
    font-family: Avenir;
    font-size: 14px !important;
    font-weight: 500;
    line-height: 16.39px;
    text-align: left;
  }
  .intru-txt-value {
    font-family: Avenir;
    font-size: 15px !important;
    font-weight: 800;
    line-height: 17.76px;
    text-align: center;
  }
  .active-member {
    font-family: Avenir;
    font-size: 14px !important;
    font-weight: 400;
    line-height: 15.03px;
    text-align: center;
  }
  .title {
    background: #2d8cff;
    color: #fff;
    font-weight: bold;
    font-size: 1.25rem;
    font-weight: bold;
    font-family: "Avenir";
  }
  .edit-group-details > div {
    border-radius: 8px;
    border: 1px solid #e4e4e4;
    // border: 1px solid black;
    box-sizing: border-box;
    padding: 15px 5px !important;

    background-color: #fff;
    text-align: center;
  }
  .edit-group-details > div > div:first-child {
    font-family: Avenir;
    font-size: 16px !important;
    font-weight: 800;
    line-height: 21.86px !important;
    text-align: left;
  }
  .edit-group-details > div > div:nth-child(2) {
    font-family: Avenir;
    font-size: 12px !important;
    font-weight: 400;
    line-height: 16.39px !important;
    text-align: center;
    color: #828282;
  }
  .row-gap {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px !important; /* 16px gap between rows and columns */
    margin-top: 16px;
    justify-content: center;
  }
  .main-label {
    font-family: Avenir;
    font-size: 17px !important;
    font-weight: 800;
    line-height: 19.12px !important;
    text-align: left;
  }
  .details > div:first-child {
    font-family: Avenir;
    font-size: 17px !important;
    font-weight: 800;
    line-height: 32.78px !important;
    color: #333333d6;
  }
  .details > div:nth-child(2) {
    font-family: Avenir;
    font-size: 15px !important;
    font-weight: 500;
    line-height: 15.03px !important;
    text-align: left;
  }
  .padding-metrics {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
  .key-offering-txt {
    font-family: Avenir;
    font-size: 12px !important;
    font-weight: 500;
    line-height: 15px !important;
    text-align: left;
  }
  .sebi-ria {
    font-family: Avenir;
    padding: 2px;
    font-size: 11px !important;
    font-weight: 500;
    line-height: 15.03px !important;
    text-align: left;
  }
  .tabs-width {
    min-width: 6px !important;
    font-size: 10px !important;
    padding: 0px !important;
    // height: 20px !important;
    border-radius: 8px;
  }
  .v-tabs {
    // width: 75% !important;
  }
}

.user-name {
  background-color: #add8e6;
  color: #333333;
  width: 152px;
  height: 152px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-name > div {
  font-size: 43px;
}

.group-user-img {
  width: 55px;
  height: 55px;
  border-radius: 8px;
}
.bg-group {
  background-color: #fafafa;
}
.contact-title {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333ad;
}
.contact-descr {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 400;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.grievance-off {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
  color: #333333;
}
.bottom-nav {
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  top: auto;
  background-color: #fff;
  z-index: 20;
}
.group-contact {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}
.contact-section > div {
  margin: 7px 0;
}
.view-disclosure {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #2d8cff;
}
.bg-color {
  background-color: #111111;
}
.show-more {
  color: #2d8cff;
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
.user-abs {
  position: absolute;
  bottom: -70px;
  left: 15px;
}
.duration-tabs {
  background-color: #d2e7ff;
}
.user-image {
  width: 152px;
  height: 152px;
  border-radius: 4px;
}
::v-deep.v-tabs > .v-tabs-bar {
  height: 34px !important;
}
.tabs-width {
  // width: 56px !important;
  min-width: 56px;
  height: 34px;
  border-radius: 8px;
}
::v-deep.v-application--is-ltr
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-bar__content
  > *:first-child:not(.v-tabs-slider-wrapper) {
  width: 56px !important;
}
// ::v-deep.v-tabs
//   > .v-slide-group
//   > .v-slide-group__wrapper
//   > .v-slide-group__content
//   > .tabs-width {
//   width: 56px !important;
// }
.market-header {
  color: hsl(0deg 0% 0% / 87%);
  font-family: Avenir;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.edit-group-details {
  // padding: 2.5px;
  border-radius: 8px;
  // border: 1px solid #e4e4e4;
  background: #f5f5f5; /* Optional background for visibility */
  text-align: center;
}
.details {
  text-align: center;
}
.details > div:first-child {
  font-family: Avenir;
  font-size: 24px;
  font-weight: 800;
  line-height: 32.78px;
  color: #333333d6;
}
.padding-metrics {
  padding-left: 80px;
  padding-right: 80px;
}
.key-offer {
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  background-color: #fff;
}
.key-offering-txt {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #333333b8;
}
.details > div:nth-child(2) {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 27.32px;
  color: #33333399;
}
.row-gap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px; /* 16px gap between rows and columns */
  margin-top: 16px;
  justify-content: center;
}
.edit-group-details > div {
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  // border: 1px solid black;
  box-sizing: border-box;
  padding: 20px;
  background-color: #fff;
  text-align: center;
}
.edit-group-details > div > div:first-child {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 900;
  line-height: 21.86px;
  text-align: center;
  color: #333333;
}
.edit-group-details > div > div:nth-child(2) {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 400;
  line-height: 16.39px;
  text-align: center;
  color: #828282;
}
.header {
  font-family: Avenir;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.left-arrow {
  transform: rotate(-45deg);
}
.br-radius {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.tooltip {
  background: #f7faff;
  opacity: 1 !important;
  // text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px !important;
}
.tooltip-text {
  color: #111111 !important;
}
.sebi-ria {
  padding: 6px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 24.59px;
  text-align: left;
  color: transparent;
  background: linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%);
  border-radius: 8px;
  -webkit-background-clip: text;
  background-clip: text;
  border: 1.62px solid black;
}
.btn-gradient-2 {
  background: linear-gradient(white, white) padding-box,
    linear-gradient(180deg, #4469b1 0%, #1d2c4b 100%) border-box;
  border-radius: 8px;
  border: 1.62px solid transparent;
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 6px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 24.59px;
  text-align: left;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
}
.edit-btn {
  text-transform: capitalize;
}
.share-btn {
  min-width: 36px !important;
  padding: 8px !important;
}
.group-header {
  font-family: Avenir;
  font-size: 28px;
  font-weight: 800;
  line-height: 38.25px;
  text-align: left;
  color: #333333;
}
.gr-subheader:hover {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
.user-img-badge {
  width: 32px;
  height: 32px;
  margin-left: auto;
  margin-right: 10px;
  // margin-top: 8px;
}
.group-subheader {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 27.32px;
  text-align: left;
  color: #33333399;
}
.intru-txt {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: left;
}
.intru-txt-value {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  text-align: center;
  color: #333333cc;
}
.active-member {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 350;
  line-height: 16.39px;
  text-align: center;
  color: #333333cc;
}
.main-label {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}
</style>
